// activeSamplingEvent/activeSamplingEventState.js

import { samplingEventFormInitialState } from "../forms/samplingEventForm/samplingEventFormState";

export const activeSamplingEventInitialState = {
  isLoading: false,
  error: null,
  currentEvent: null, // Full sampling event class instance
  currentTab: null,
  _rev: 0, // Revision counter for change detection with mutable updates
  samplingEventForm: samplingEventFormInitialState,
};
